/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InsertFileFormatDto } from './insertFileFormatDto';


export interface UpdateAssetAspectRatioDto { 
    aspectRatio?: string;
    fileFormats?: Array<InsertFileFormatDto>;
}

